import angular from "angular";
import ChangeOrganizationButtonComponent from "./change-organization-button/change-organization-button";
import ChangeOrganizationModalComponent from "./change-organization-modal/change-organization-modal";
import NavbarComponent from "./navbar/navbar";
import OrganizationImageComponent from "./organization-image/organization-image";
import OrganizationNameComponent from "./organization-name/organization-name";
import QuoterMasterLoaderComponent from "./quoter-master-loader/quoter-master-loader";
import SidebarComponent from "./sidebar/sidebar";
import UserNameComponent from "./user-name/user-name";
import VersionNumberComponent from "./version-number/version-number";

const LayoutModule = angular
  .module("modules.layout", [])
  .component("changeOrganizationButton", ChangeOrganizationButtonComponent)
  .component("changeOrganizationModal", ChangeOrganizationModalComponent)
  .component("navbar", NavbarComponent)
  .component("organizationImage", OrganizationImageComponent)
  .component("organizationName", OrganizationNameComponent)
  .component("quoterMasterLoader", QuoterMasterLoaderComponent)
  .component("sidebar", SidebarComponent)
  .component("userName", UserNameComponent)
  .component("versionNumber", VersionNumberComponent);

export default LayoutModule;
